export default {
    type: 'panel',
    name: 'reviews',
    blocks: [
        {
            // Titre affiché au dessus des avis. Vide = pas de titre.
            name: 'title',
            label: 'Titre',
            max: 1,
            type: 'text',
        },
        {
            // Hide the aggregated rating block (average score + star bar). Value stored in `.value`.
            name: 'hideSummary',
            label: 'Masquer la note moyenne',
            max: 1,
            type: 'toggle',
        },
        {
            // Hide the questions tab, keeping only reviews.
            name: 'hideQuestions',
            label: 'Masquer les questions',
            max: 1,
            type: 'toggle',
        },
        {
            name: 'hideTitle',
            label: 'Masquer le titre',
            max: 1,
            type: 'toggle',
        },
        {
            // Number of reviews shown per slide (defaults handled by ReviewSummary if empty).
            name: 'countPerSlide',
            label: 'Avis par diapositive',
            max: 1,
            type: 'text',
        },
    ],
};
